var map = {
	"./decidim/avatar-multiuser.png": 6657,
	"./decidim/brands/facebook.svg": 5093,
	"./decidim/brands/google.svg": 42060,
	"./decidim/brands/twitter-x.svg": 22297,
	"./decidim/cc-badge.png": 46247,
	"./decidim/decidim-logo.svg": 49331,
	"./decidim/default-avatar.svg": 33799,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 39165,
	"./decidim/icons.svg": 30182,
	"./decidim/pattern.png": 67333,
	"./decidim/placeholder-card-g.svg": 19210,
	"./decidim/placeholder-card-l.svg": 69089,
	"./decidim/placeholder.jpg": 23616,
	"./decidim/remixicon.symbol.svg": 38290,
	"./decidim/vendor/social-share-button/douban.svg": 17301,
	"./decidim/vendor/social-share-button/email.svg": 26326,
	"./decidim/vendor/social-share-button/facebook.svg": 75358,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 93202,
	"./decidim/vendor/social-share-button/hacker_news.svg": 52374,
	"./decidim/vendor/social-share-button/linkedin.svg": 21228,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 6149,
	"./decidim/vendor/social-share-button/pinterest.svg": 62352,
	"./decidim/vendor/social-share-button/reddit.svg": 58026,
	"./decidim/vendor/social-share-button/telegram.svg": 75291,
	"./decidim/vendor/social-share-button/tumblr.svg": 91288,
	"./decidim/vendor/social-share-button/twitter.svg": 17691,
	"./decidim/vendor/social-share-button/vkontakte.svg": 91985,
	"./decidim/vendor/social-share-button/wechat.svg": 66884,
	"./decidim/vendor/social-share-button/whatsapp.svg": 87964,
	"./decidim/vendor/social-share-button/x.svg": 60830,
	"./decidim/vendor/social-share-button/xing.svg": 43770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37908;